import React, { useState, useEffect } from 'react';
import TreatmentList from './components/TreatmentList';
import LeadManager from './components/LeadManager';
import { getTreatments, getLeads } from './api';

export default function App() {
  const [treatments, setTreatments] = useState([]);
  const [leads, setLeads] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const tData = await getTreatments();
      setTreatments(tData);
      const lData = await getLeads();
      setLeads(lData);
    }
    fetchData();
  }, []);

  return (
    <div style={{ padding: 20, fontFamily: 'system-ui, sans-serif', maxWidth: 1200, margin: 'auto' }}>
      <h1>Dental Cost Estimator Admin Dashboard</h1>
      <TreatmentList treatments={treatments} setTreatments={setTreatments} />
      <hr style={{ margin: '40px 0' }} />
      <LeadManager leads={leads} />
    </div>
  );
}
